import GlobalStyles from '@mui/material/GlobalStyles';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const defaultTheme = createTheme();

const temaConfig = createTheme({
    components: {
        MuiButton: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                ...(ownerState.variant === 'contained' &&
                    ownerState.color === 'success' && {
                    backgroundColor: '#202020',
                    color: '#00000',
                    }),
                }),
            },
            variants: [
                {
                    props: { variant: 'contained' },
                    style: {
                        textTransform: 'none',
                        border: `2px dashed ${defaultTheme.palette.primary.main}`,
                        color: defaultTheme.palette.primary.main,
                    },
                },
                {
                    props: { variant: 'contained', color: 'secondary' },
                    style: {
                        border: `2px dashed ${defaultTheme.palette.secondary.main}`,
                        color: defaultTheme.palette.secondary.main,
                    },
                },
                {
                    props: { variant: 'contained', size: 'large' },
                    style: {
                        borderWidth: 4,
                    },
                },
                {
                    props: { variant: 'contained', color: 'secondary', size: 'large' },
                    style: {
                        fontSize: 18,
                    },
                },
            ],
        },
    },

    palette: {
        primary: {
            main: '#6d86b4'
        },
        secondary: {
            main: '#000000',
        },
        default: {
            main: '#000000'
        },
        info: {
            main: '#25A9FF'
        },
        success: {
            main: '#000000'
        },
        warning: {
            main: '#FF9B12'
        },
        error: {
            main: '#F44336'
        }
    }
})

export default temaConfig;